<template>
  <div class='otherFees'>
    <div class='nav'>
      <div class='navContainer' style='width: 230px'>
        <p>费用编号：</p>
        <el-input v-model='shipIpt' size='mini' style='width:150px' placeholder='请输入费用编号' />
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>公司类型：</p>
        <el-input v-model='voyageIpt' size='mini' style='width:150px' placeholder='请输入公司类型' />
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>公司名称：</p>
        <el-input v-model='numberIpt' size='mini' style='width:150px' placeholder='请输入公司名称' />
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>费用类型：</p>
        <el-input v-model='batchIpt' size='mini' style='width:150px' placeholder='请输入费用类型' />
      </div>
      <div class='navContainer' style='width: 400px'>
        <p>费用时间：</p>
        <el-date-picker v-model='timeIpt[0]' size='mini' style='width:150px'
                        value-format='yyyy-MM-dd HH:mm:ss' @change='dateChange' type='datetime'
                        placeholder='开始日期' />
        <span style='display:inline-block;width:15px;text-align:center;font-size:18px'>-</span>
        <el-date-picker v-model='timeIpt[1]' size='mini' style='width:150px'
                        value-format='yyyy-MM-dd HH:mm:ss' @change='dateChange' type='datetime'
                        placeholder='结束日期' />
      </div>
      <!-- <div class="navContainer" style="width: 270px">
        <p>是否生成对账单：</p>
        <el-select v-model="typeIpt" size="mini" filterable style="width:150px">
          <el-option v-for="item in typeOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div> -->
      <div class='navBtn'>
        <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
        <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
      </div>
    </div>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label='序号' align='center' width='50px' type='index' />
          <el-table-column prop='costNum' label='费用编号' align='center' min-width='120'
                           show-overflow-tooltip />
          <el-table-column prop='companyType' label='公司类型' align='center'>
            <template slot-scope='scope'>{{ getDeliveryAddressType(scope.row.companyType) }}
            </template>
          </el-table-column>
          <el-table-column prop='companyName' label='公司名称' align='center' min-width='150'
                           show-overflow-tooltip />
          <el-table-column prop='costTypeName' label='费用类型' align='center' />
          <el-table-column prop='costInstruction' label='费用说明' align='center' min-width='150'
                           show-overflow-tooltip />
          <el-table-column prop='costTime' label='费用时间' align='center' min-width='150' />
          <el-table-column prop='taxRate' label='税率(%)' align='center' />
          <el-table-column prop='costAmount' label='费用金额' align='center' />
          <!-- <el-table-column prop="isStatement" label="生成对账单" align="center"/> -->
          <el-table-column label='操作' width='210' align='center'>
            <template slot-scope='scope'>
              <el-button size='mini' class='searchBtn' type='primary'
                         @click='detailClick(scope.row.id)'>详情
              </el-button>
              <el-button v-if='scope.row.auditType==1&&scope.row.choise==1' size='mini'
                         type='primary' @click='enableClick(scope.row.id)'>同意
              </el-button>
              <el-button v-if='scope.row.auditType==1&&scope.row.choise==1' size='mini'
                         type='danger' @click='disableClick(scope.row.id)'>拒绝
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='sizes,prev, pager, next,jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          @prev-click='contractCurrentChange'
          @next-click='contractCurrentChange'
        />
      </div>
    </div>
    <el-dialog title='详情' :visible.sync='detailShowFlag' width='900px' center top='10vh'
               :close-on-click-modal='false'>
      <div class='detail' v-loading='detailLoading'>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>基础信息</span>
          </div>
          <div class='baseInfoContent'>
            <div class='baseInfoContentItem'>
              <span class='span1'>费用编号：</span>
              <span>{{ detailData.costNum }}</span>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>公司类型：</span>
                <span>{{ getDeliveryAddressType(detailData.companyType) }}</span>
              </div>
              <div>
                <span class='span1'>公司名称：</span>
                <span>{{ detailData.companyName }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>费用类型：</span>
              <span>{{ detailData.costTypeName }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>费用说明：</span>
              <span>{{ detailData.costInstruction }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>费用时间：</span>
              <span>{{ detailData.costTime }}</span>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>税率：</span>
                <span>{{ detailData.taxRate }}%</span>
              </div>
              <div>
                <span class='span1'>费用金额：</span>
                <span>{{ detailData.costAmount }}元</span>
              </div>
            </div>
            <div class='operation'
                 v-if='detailData.attachmentList  && detailData.attachmentList.length > 0'>
              <div class='operationTitle'>
                <div class='line' />
                <span>附件信息</span>
              </div>
              <div class='baseInfoContent'>
                <div style='display: flex'>
                  <el-form :model='detailData' label-position='left' style='width: 100%'>
                    <el-row :gutter='30' style='width: 100%' v-for='(item,index) in detailData.img'
                            :key='`${index}b`'>
                      <el-col :span='14'>
                        <el-form-item>
                          {{ item.name }}
                        </el-form-item>

                      </el-col>
                      <el-col :span='7'>
                        <el-form-item>{{ item.uploadTime }}</el-form-item>
                      </el-col>
                      <el-col :span='3'>
                        <el-form-item>
                          <i class='el-icon-zoom-in' @click='handlePictureCardPreview(item,index)'
                             v-if="item.name.substring(item.name.indexOf('.')) == '.jpeg'
                           ||item.name.substring(item.name.indexOf('.')) == '.jpg'
                             ||item.name.substring(item.name.indexOf('.')) == '.png'
                             || item.name.substring(item.name.indexOf('.')) == '.gif'"></i>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
            <div class='baseInfo'>
              <div class='baseInfoTitle'>
                <div class='line' />
                <span>审核信息</span>
              </div>
              <steps :step-data='stepData' :step-state='stepState' />
            </div>
            <div class='baseInfo' v-if='detailData.auditType==1&&detailData.choise==1'>
              <div class='baseInfoTitle'>
                <div class='line' />
                <span>操作</span>
              </div>
              <div class='baseInfoContentItem'>
                <div style='display: flex;margin:10px 20px 0 15px;'>
                  <span class='span1' style='width: 70px;'><span
                    style='color:red'>*</span>原因：</span>
                  <el-input
                    type='textarea'
                    :style="'width:100%'"
                    v-model='remark'
                    placeholder='请填写同意/拒绝原因'
                    autocomplete='off'
                    size='small'
                  />
                </div>
              </div>
            </div>
            <div v-if='detailData.auditType==1&&detailData.choise==1'
                 style='display: flex;align-items: center;justify-content: center'>
              <el-button size='medium' type='primary' @click='agreeClick'>同意</el-button>
              <el-button size='medium' type='danger' @click='refusedClick'>拒绝</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title='图片预览' :visible.sync='dialogImageVisible' append-to-body>
      <img width='100%' :src='dialogImageUrl' alt=''>
    </el-dialog>
  </div>
</template>

<script>
  import {
    baseUrl,
  } from '@/config/env';
  import steps from '@/components/steps';
  import { otherAudit } from '@/service/contract';
  import {
    othercostCtherCostDetail,
    othercostReviewSubmit,
  } from '@/service/audit';
  import { getSessionStore } from '@/config/mUtils';
  import { selectListBySourceId } from '@/service/getData';

  export default {
    components: { steps },
    data() {
      return {
        companyData: {},
        shipIpt: '',
        voyageIpt: '',
        batchIpt: '',
        numberIpt: '',
        chassisIpt: '',
        typeIpt: '',
        timeIpt: ['', ''],
        typeOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 0,
            label: '否',
          },
          {
            value: 1,
            label: '是',
          },
          {
            value: 2,
            label: '部分生成',
          },
        ],
        page: 1,
        size: 10,
        total: 0,
        tableLoad: false,
        TableDatas: [],
        detailShowFlag: false,
        detailLoading: false,
        detailData: {},
        stepData: [],
        remark: '',
        dialogImageUrl: '',
        dialogImageVisible: false,
      };
    },
    created() {
      this.searchBtn();
    },
    computed: {
      stepState() {
        return function(state) {
          switch (state) {
            case '':
              return 'wait';
            case 'success':
              return 'success';
            case 'failure':
              return 'error';
          }
        };
      },
      getStyle() {
        return (val) => {
          switch (val) {
            case 2:
              return 'color: rgba(51, 136, 255, 1);';
            case 1:
              return 'color: rgba(249, 166, 6, 1)';
            case 3:
              return 'color:#F56C6C;';
            case 4:
              return 'color:#F56C6C;';
          }
        };
      },
      getState() {
        return function(state) {
          switch (state) {
            case 1:
              return '待审核';
            case 2:
              return '已通过';
            case 3:
              return '已拒绝';
            case 4:
              return '已取消';
          }
        };
      },
      getDeliveryAddressType() {
        return function(type) {
          switch (type) {
            case 0:
              return '委托商';
            case 1:
              return '公路供应商';
            case 2:
              return '水路供应商';
            case 3:
              return '港口及其他';
          }
        };
      },
    },
    mounted() {
      this.init();
    },
    methods: {
      handlePictureCardPreview(item, index) {
        console.log(item);
        let token = getSessionStore('token');
        this.dialogImageUrl = baseUrl + '/web/attachmentFtp/download?attachmentId=' + (item.id || item.response.data.id) + '&access_token=' + token;

        this.dialogImageVisible = true;
      },
      init() {
        this.uploadUrl = baseUrl + '/web/attachment/upload';
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        this.searchBtn();
      },
      contractCurrentChange(page) {
        this.page = page;
        this.searchBtn();
      },
      // 查询
      searchBtn() {
        this.page = 1;
        const data = {
          page: this.page,
          row: this.size,
          costNum: this.shipIpt,//费用编号
          companyType: this.voyageIpt,//公司类型
          companyName: this.numberIpt,//公司名称
          costType: this.batchIpt,//费用类型
          startTime: this.timeIpt[0] === undefined ? '' : this.timeIpt[0],//开始时间
          endTime: this.timeIpt[1] === undefined ? '' : this.timeIpt[1],//结束时间
          // isStatement:this.typeIpt,//是否生成对账单
        };
        this.expensepaging(data);
      },
      // 分页查询
      async expensepaging(data) {
        const res = await otherAudit(data);
        if (res.status == '0') {
          this.total = res.data.total;
          res.data.records.forEach(item => {
            if (item.isStatement == 1) {
              item.isStatement = '是';
            } else {
              item.isStatement = '否';
            }
          });
          this.TableDatas = res.data.records;
        } else {
          this.$message.error(res.message);
        }
      },
      compareDate(d1, d2) {
        return ((new Date(d1.replace(/-/g, '\/'))) > (new Date(d2.replace(/-/g, '\/'))));
      },
      // 结束时间
      dateChange(val) {
        if (this.timeIpt[1] && this.timeIpt[0] && this.compareDate(this.timeIpt[0], this.timeIpt[1])) {
          if (val == this.timeIpt[1]) this.timeIpt[1] = '';
          if (val == this.timeIpt[0]) this.timeIpt[0] = '';
          this.$forceUpdate();
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      // 重置
      resetBtn() {
        this.shipIpt = '';
        this.voyageIpt = '';
        this.batchIpt = '';
        this.numberIpt = '';
        this.chassisIpt = '';
        this.timeIpt = ['', ''];
        // this.typeIpt='';
      },
      // 详情
      async detailClick(id) {
        this.detailShowFlag = true;
        this.detailLoading = true;
        let res = await othercostCtherCostDetail(id);
        let res2 = await selectListBySourceId(id);
        this.detailLoading = false;
        if (res.status !== 0) return this.$message.warning(res.message);
        if (res2.status !== 0) return this.$message.warning(res.message);
        this.detailData = res.data;
        let array = res2.data.map(item => {
          return {
            name: item.attachmentName,
            url: this.baseImgUrl + item.attachmentGroup + '/' + item.attachmentPath,
            status: 'success',
            id: item.id,
            uploadTime: item.uploadTime,
          };
        });
        this.$set(this.detailData, 'img', array);
        this.stepData = [];
        if (res.data.auditRecordList.length > 0) {
          res.data.auditRecordList.forEach((item) => {
            let status = '',
              temp = {},
              text = '取消审核';
            if (item.status == 1) {
              text = '发起';
            }
            if (item.status == 0) {
              text = '重新发起';
            }
            if (item.status == 3) {
              status = 'failure', text = '拒绝';
              temp = {
                'title': item.deptName + ' ' + item.auditorName + ' ' + text,
                'time': item.createTime,
                'state': status,
                'remark': item.opinion,
              };
            } else if (item.status == 2) {
              status = 'success', text = '同意';
              temp = {
                'title': item.deptName + ' ' + item.auditorName + ' ' + text,
                'time': item.createTime,
                'state': status,
                'remark': item.opinion,
              };
            } else {
              temp = {
                'title': item.auditorName + ' ' + text,
                'time': item.createTime,
                'state': status,
                'remark': '',
              };
            }
            this.stepData.push(temp);
          });
        }
      },
      // 同意
      enableClick(id) {
        this.$prompt('确认同意当前其他费用申请吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'textarea',
          inputValidator: function(value) {
            if (!value) {
              return false;
            }
          },
          inputErrorMessage: '同意原因不能为空',
          type: 'warning',
        })
          .then(async ({ value }) => {
            const res = await othercostReviewSubmit({
              id: id,
              auditOpinion: value,
              //t同意
              reviewResult: 'AGREE',
            });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.detailShowFlag = false;
            this.searchBtn();
          })
          .catch(() => {
          });
      },
      // 拒绝
      disableClick(id) {
        this.$prompt('确认拒绝当前其他费用申请吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'textarea',
          inputValidator: function(value) {
            if (!value) {
              return false;
            }
          },
          inputErrorMessage: '拒绝原因不能为空',
          type: 'warning',
        })
          .then(async ({ value }) => {
            const res = await othercostReviewSubmit({
              id: id,
              auditOpinion: value,
              //拒绝
              reviewResult: 'REFUSE',
            });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.detailShowFlag = false;
            this.searchBtn();
          })
          .catch(() => {
          });
      },
      // 详情同意
      async agreeClick() {
        this.remark = this.remark.trim();
        if (!this.remark) return this.$message.warning('请填写同意理由！');
        const res = await othercostReviewSubmit({
          id: this.detailData.id,
          auditOpinion: this.remark,
          // 同意
          reviewResult: 'AGREE',
        });
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this.detailShowFlag = false;
        this.remark = '';
        this.searchBtn();
      },
      // 详情拒绝
      async refusedClick() {
        this.remark = this.remark.trim();
        if (!this.remark) return this.$message.warning('请填写拒绝理由！');
        const res = await othercostReviewSubmit({
          id: this.detailData.id,
          auditOpinion: this.remark,
          // 拒绝
          reviewResult: 'REFUSE',
        });
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this.detailShowFlag = false;
        this.remark = '';
        this.searchBtn();
      },
    },
  };
</script>

<style lang='scss' scoped>
  .otherFees {
    width: 100%;
    padding: 20px 15px 0 25px;
    background-color: #fff;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-top: 10px;
        margin-bottom: 25px;
        width: 100%;

        &Nav {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;

          span {
            color: rgba(51, 136, 255, 1);
            text-decoration: underline;
            margin-right: 10px;

            &:hover {
              cursor: pointer;
            }
          }
        }

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 70vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        .attachment {
          display: flex;
          flex-direction: column;
          padding-top: 10px;

          &Item {
            width: 80%;
            margin-bottom: 10px;
            margin-left: 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            span {
              color: #969696;
              font-size: 14px;
            }
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td, .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }
  }

  ::v-deep {
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }
  }
</style>
